import type { ReactNode } from 'react';
import type { DocumentHint } from '@oscom/shared';

/** Hints of the current render result; information only, nothing is blocked. */
export function DocumentHints({
  hints,
  loading,
  error,
  onSelect,
  onRefresh,
}: {
  hints: readonly DocumentHint[];
  loading: boolean;
  error: string | undefined;
  onSelect: (sectionId: string) => void;
  onRefresh: () => void;
}): ReactNode {
  return (
    <aside className="doc-hints card" aria-label="Prüfhinweise">
      <h2>Prüfhinweise</h2>
      <button type="button" className="button button--ghost" disabled={loading} onClick={onRefresh}>
        Aktualisieren
      </button>
      {error ? <p className="notice notice--warning">{error}</p> : null}
      {hints.length === 0 ? (
        <p className="muted">Keine Hinweise.</p>
      ) : (
        <ul>
          {hints.map((hint, index) => (
            <li key={`${hint.renderedId}-${hint.kind}-${index}`}>
              {hint.sectionId ? (
                <button
                  type="button"
                  className="doc-hints__entry"
                  onClick={() => onSelect(hint.sectionId as string)}
                >
                  {hint.message}
                </button>
              ) : (
                hint.message
              )}
            </li>
          ))}
        </ul>
      )}
      <p className="muted small">Die Hinweise sperren das Dokument nicht.</p>
    </aside>
  );
}
